/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Grouping_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Grouping Options" |
*
* @param {Transcript_Export_Grouping_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_grouping_options_label = /** @type {((inputs?: Transcript_Export_Grouping_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Grouping_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de regroupement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppierungsoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di raggruppamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры группировки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de agrupación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分组选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ化オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूहीकरण विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de agrupamento")
	return /** @type {LocalizedString} */ ("Grouping Options")
});